import CitationDetail from './CitationDetail';
export default CitationDetail;
